<template>
    <div>
        <Header :headerData="headerData"></Header>
        <a-select 
            v-model:value="protocolType" 
            :options="protocolOptions"  
            style="width: 200px; margin-top: 20px;"
            @change="handleProtocolChange"
        ></a-select>
        <div class="list">
            <div v-if="list.length>0" class="echart" id="chart1" :style='{float: "left",width: "100%",height: "400px" }'></div>
            <div v-if="list.length>0" class="echart" id="chart2" :style='{float: "left",width: "100%",height: "400px" }'></div>
            <div v-if="list.length>0" class="echart" id="chart3" :style='{float: "left",width: "100%",height: "400px" }'></div>
            <div v-if="list.length>0" class="echart" id="chart4" :style='{float: "left",width: "100%",height: "400px" }'></div>
            <div v-if="list.length>0" class="echart" id="chart5" :style='{float: "left",width: "100%",height: "400px" }'></div>
            <div v-if="list.length>0" class="echart" id="chart6" :style='{float: "left",width: "100%",height: "400px" }'></div>
        </div>
    </div>
</template>

<script setup>
    import { onMounted, onUnmounted, nextTick, ref} from "vue";
    import { PartDistributionApi } from '@/api/PartDistributionApi.js';
    import { useI18n } from 'vue-i18n';
    import * as echarts from "echarts";
    import { Modal } from 'ant-design-vue'
    import Header from '@/layouts/component/Header.vue';
    import { getWeek } from '@/hooks/useGetWeek';

    const { t } = useI18n()
    const list  = ref([])
    const headerData = ref({
        menu:'menu.PartsVersionStatistic',
        menu_desc:'menu.subPartsVersionStatistic',
        week: getWeek().week,
        current_time:getWeek().currentDate,
    })

    const charts = ref([])
    const protocolType = ref('0')
    const protocolOptions = ref([
        { label: 'PLC', value: '0' },
        { label: 'CAN', value: '1' },
    ])
    let resizeObservers = []

    const resizeAllCharts = () => {
        if (!charts.value || charts.value.length === 0) return
        charts.value.forEach((chartInstance) => {
            try { chartInstance.resize({ animation: false }) } catch (e) {}
        })
    }

    const initCharts = async () => {
        // dispose previous charts and observers
        if (charts.value.length > 0) {
            charts.value.forEach((inst) => { try { inst.dispose() } catch (e) {} })
            charts.value = []
        }
        if (resizeObservers.length > 0) {
            resizeObservers.forEach((ro) => { try { ro.disconnect() } catch (e) {} })
            resizeObservers = []
        }

        await nextTick()

        for (var i = 0; i < list.value.length; i++) {
            let statisticData = list.value[i]
            const dom = document.getElementById("chart" + (i + 1))
            if (!dom) continue
            const chart = echarts.init(dom)
            chart.clear()
            let option =  {
                graphic: [{
                    type: 'text',
                    left: '25%',
                    top: '50%',
                    bottom:'10%',
                    z: 100,
                    style: {
                        textAlign: 'center',
                        fill: '#000',
                        fontSize: 14
                    }
                }],    
                title: {
                    text: statisticData.label,   //标题
                    left: '5%',
                    top:'10%'
                },
                series: [
                    {
                        type: "pie", //形状为饼状图
                        radius: '50%',
                        center: ['50%','55%'],
                        data: statisticData.data,
                        label: {
                            show: true,
                            position: 'outside',
                            formatter: (params) => {
                                const name = params && params.name ? params.name : ''
                                const percent = (params && typeof params.percent !== 'undefined') ? params.percent : ''
                                const value = (params && typeof params.value !== 'undefined') ? params.value : ''
                                return `V${name}, ${percent}%, ${value} `
                            }
                        },
                        labelLine: { length: 30 }
                    },
                ],
            };
            chart.setOption(option);
            charts.value.push(chart)

            // Observe container size changes to keep chart centered
            try {
                const ro = new ResizeObserver(() => {
                    try { chart.resize({ animation: false }) } catch (e) {}
                })
                ro.observe(dom)
                resizeObservers.push(ro)
            } catch (e) {}
        }  

        resizeAllCharts()

    }

    const getStatisticData = async ()=> {
        let param = {
            protocol: protocolType.value,
        }
        let res = await PartDistributionApi.getInstance().partVersionStatistics(param)
        if (!res.code) {
            if (res.data.length == 0) {
                Modal.warn({ title: t('base.tip'), content: t('dataSearch.query_data_empty') })
            }
            list.value = res.data
        } else {
            Modal.error({ title: t('base.tip'), content: res.msg, })
        }
      
    }

    const handleSearch = async ()=>{
        await getStatisticData()
        initCharts()
    }

    const handleProtocolChange = async ()=>{
        await getStatisticData()
        initCharts()
    }

    onMounted(()=>{
        handleSearch()
        window.addEventListener('resize', resizeAllCharts)
        window.addEventListener('orientationchange', resizeAllCharts)
    })

    onUnmounted(()=>{
        window.removeEventListener('resize', resizeAllCharts)
        window.removeEventListener('orientationchange', resizeAllCharts)
        if (resizeObservers.length > 0) {
            resizeObservers.forEach((ro) => { try { ro.disconnect() } catch (e) {} })
            resizeObservers = []
        }
        if (charts.value.length > 0) {
            charts.value.forEach((inst) => { try { inst.dispose() } catch (e) {} })
            charts.value = []
        }
    })
</script>

<style lang="scss" scoped>
#mileageChart{
    width: 100%;
    height: 500px;
}

#timeChart{
    width: 100%;
    height: 500px;
}

.list{
    margin-top: 20px;
    .table_setting{
        cursor: pointer;
    }

    ::v-deep .right_table_setting .anticon{
        font-size: 12px !important;
        margin: 5px 5px !important;
    }
    
    ::v-deep .ant-table {
        th,td {
            text-align: center;
        }
    }

    ::v-deep .ant-form{
        margin-left: -38px;
    }
}

::v-deep .page_header .week{
    margin-top: -55px;
    transform: translateY(8px);
}
::v-deep .page_header .admin_email{
    margin-top: -55px;
    transform: translateY(18px);
}

// 当sub不为空时
// ::v-deep .page_header .week{
//     margin-top: -70px;
// }
// ::v-deep .page_header .admin_email{
//     margin-top: -60px;
// }

::v-deep .ant-picker{
    width: 100%;
}

.echart{
    float: left;
    margin: 10px 0;
    width: 100%;
    height: 400px;
    box-shadow: 0px 0px 16px -3px #ccc;
}
</style>